import { z, zCoercedBoolean } from '@harvestiq/zod';
import {
  CoverageTiers,
  RmaLgmCommodityCodes,
  RmaLgmTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalNullable } from '@harvestiq/zod';

export const downloadLgmQuoteRequestSchema = z.object({
  commodityCode: z.nativeEnum(RmaLgmCommodityCodes),
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().optional(),
  deductibles: z.array(z.coerce.number().int().min(0).max(150)),
  liveCattleTargetCwtPerHead: zDecimalNullable().optional(),
  feederCattleTargetCwtPerHead: zDecimalNullable().optional(),
  cornTargetBuPerHead: zDecimalNullable().optional(),
  coverageTier: z.nativeEnum(CoverageTiers).nullable().optional(),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
});

export type DownloadLgmQuoteRequest = z.input<
  typeof downloadLgmQuoteRequestSchema
>;

export const downloadLgmQuoteResponseItemSchema = z.object({
  filename: z.string(),
  salesEffectiveDate: zCalendarDate(),
});

export type DownloadLgmQuoteResponseItem = z.infer<
  typeof downloadLgmQuoteResponseItemSchema
>;

export const downloadLgmQuoteResponseSchema = z
  .object({
    data: z.array(downloadLgmQuoteResponseItemSchema),
  })
  .or(
    z.object({
      message: z.string(),
    })
  );

export type DownloadLgmQuoteResponse = z.infer<
  typeof downloadLgmQuoteResponseSchema
>;
